/* eslint-disable node/no-unsupported-features/es-syntax */
import { CLIENT_ROUTE_NAMES } from "@/shared";
export const CLIENT_ROUTES = [
    {
        name: CLIENT_ROUTE_NAMES.LIST,
        path: "/client",
        meta: {
            title: "menu.clients",
        },
        component: () => import("../ui/ClientPage.vue"),
        props: (route) => ({
            ...route.params,
            ...route.query,
        }),
    },
    {
        name: CLIENT_ROUTE_NAMES.PROFILE,
        path: "/client/:clientId",
        meta: {
            title: "words.client_profile",
        },
        component: () => import("../ui/ClientProfile.vue"),
    },
    {
        name: CLIENT_ROUTE_NAMES.ADD,
        path: "/client/add",
        meta: {
            title: "words.add_client",
        },
        component: () => import("../ui/ClientEdit.vue"),
        props: (route) => ({
            ...route.params,
            ...route.query,
        }),
    },
    {
        name: CLIENT_ROUTE_NAMES.EDIT,
        path: "/client/edit/:clientId",
        meta: {
            title: "words.edit_client",
        },
        component: () => import("../ui/ClientEdit.vue"),
        props: true,
    },
];
